import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { VistaAdminInfoI } from '../modelos/VistaAdminInfo';
import { ResCargueExcel } from '../modelos/ResCargueExcel';
import { Panel3OperativoI } from '../modelos/Panel3Operativo';
import { ResCargueExcelFivi } from '../modelos/ResCargueExcelFivi';

@Injectable({
  providedIn: 'root'
})
export class AppServiceService {
  downloadFile(data, filename='data') {
      let csvData = this.ConvertToCSV(data, ['nit', 'razon', 'operacion', 'departamento', 'telefono', 'email', 'estado']);
      console.log(csvData)
      let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
      let dwldLink = document.createElement("a");
      let url = URL.createObjectURL(blob);
      let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
      if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_blank");
      }
      dwldLink.setAttribute("href", url);
      dwldLink.setAttribute("download", filename + ".csv");
      dwldLink.style.visibility = "hidden";
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
  }
  downloadFileUsers(data, filename='data') {
    let csvData = this.ConvertToCSV(data, ['tipo', 'usuario', 'nombre', 'telefono', 'email', 'estado']);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    //debugger;
    let str = '';
    let row = 'S.No;';
    for (let index in headerList) {
            row += headerList[index] + ';';
        }
        row = row.slice(0, -1);
        str += row + '\r\n';
        for (let i = 0; i < array.length; i++) {
            let line = (i+1)+'';
            for (let index in headerList) {
                let head = headerList[index];
                line += ';' + array[i][head];
            }
            str += line + '\r\n';
        }
        return str;
  }

  downloadResCargue(data, filename='data') {
    let csvData = this.CargueMasivoToCSV(data, ['consecutivo','trimestre','anio', 'tipo_de_credito', 'departamento', 'municipio', 'solucion_vivienda', 'tenedor', 'moneda', 'rango_vivienda', 'mora', 'numero_creditos', 'saldo_capital_total', 'capital_una_mas_cuotas_vencidad', 'tasa']);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  CargueMasivoToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      //debugger;
      let str = '';
      let row = 'S.No;';
      for (let index in headerList) {
              row += headerList[index] + ';';
          }
          row = row.slice(0, -1);
          str += row + '\r\n';
          for (let i = 0; i < array.length; i++) {
              let line = (i+1)+'';
              for (let index in headerList) {
                  let head = headerList[index];
                  line += ';' + array[i][head];
              }
              str += line + '\r\n';
          }
          return str;
  }

  downloadResConsulta(data, filename='data') {
    let csvData = this.ConsultaToCSV(data, ['anio','trimestre', 'tipo_de_credito', 'departamento', 'municipio', 'solucion_vivienda', 'tenedor', 'moneda', 'rango_vivienda', 'mora', 'numero_creditos', 'saldo_capital_total', 'capital_una_mas_cuotas_vencidad', 'tasa']);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConsultaToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      //debugger;
      let str = '';
      let row = 'consecutivo;';
      for (let index in headerList) {
              row += headerList[index] + ';';
          }
          row = row.slice(0, -1);
          str += row + '\r\n';
          for (let i = 0; i < array.length; i++) {
              let line = (i+1)+'';
              for (let index in headerList) {
                  let head = headerList[index];
                  line += ';' + array[i][head];
              }
              str += line + '\r\n';
          }
          return str;
  }

  downloadResCargueFivi(data, filename='data') {
    let csvData = this.CargueMasivoFiviToCSV(data, ['consecutivo','anio','mes', 'operacion_financiera', 'sexo_titular', 'edad_titular', 'destino_credito', 'solucion_vivienda', 'destino_credito_vivienda', 'destino_credito_construccion', 'departamento', 'municipio', 'departamento_vivienda', 'municipio_vivienda', 'subsidio', 'tipo_de_subsidio', 'moneda', 'rango_vivienda', 'numero_creditos', 'valor_avaluo', 'numero_de_desembolso', 'valor_credito', 'plazo_credito']);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  CargueMasivoFiviToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      //debugger;
      let str = '';
      let row = 'S.No;';
      for (let index in headerList) {
              row += headerList[index] + ';';
          }
          row = row.slice(0, -1);
          str += row + '\r\n';
          for (let i = 0; i < array.length; i++) {
              let line = (i+1)+'';
              for (let index in headerList) {
                  let head = headerList[index];
                  line += ';' + array[i][head];
              }
              str += line + '\r\n';
          }
          return str;
  }

//CARGUE MASIVO MODULO ADMINISTRACION INFORMACION
  downloadResCargueAdminInfo(data, filename='data') {
    let csvData = this.CargueMasivoAdminInfoToCSV(data, ['consecutivo','anio','trimestre','codigo_entidad','tipo_de_credito','departamento','municipio','solucion_vivienda','tenedor','moneda','rango_vivienda','mora','numero_creditos','saldo_capital_total','capital_una_mas_cuotas_vencidad','tasa']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  CargueMasivoAdminInfoToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      //debugger;
      let str = '';
      let row = 'S.No;';
      for (let index in headerList) {
              row += headerList[index] + ';';
          }
          row = row.slice(0, -1);
          str += row + '\r\n';
          for (let i = 0; i < array.length; i++) {
              let line = (i+1)+'';
              for (let index in headerList) {
                  let head = headerList[index];
                  line += ';' + array[i][head];
              }
              str += line + '\r\n';
          }
          return str;
  }

  CargueMasivoFiviAdminInfo(data, filename='data') {
    let csvData = this.CargueMasivoFiviAdminInfoToCSV(data, ['ANIO','MES', 'OPERACION_FINANCIERA', 'SEXO_TITULAR', 'EDAD_TITULAR', 'DESTINO_CREDITO', 'SOLUCION_VIVIENDA', 'DESTINO_CREDITO_VIVIENDA', 'DESTINO_CREDITO_CONSTRUCCION', 'DEPARTAMENTO', 'MUNICIPIO', 'DEPARTAMENTO_VIVIENDA', 'MUNICIPIO_VIVIENDA', 'SUBSIDIO', 'TIPO_DE_SUBSIDIO', 'MONEDA', 'RANGO_VIVIENDA', 'NUMERO_CREDITOS', 'VALOR_AVALUO', 'NUMERO_DE_DESEMBOLSO', 'VALOR_CREDITO', 'PLAZO_CREDITO']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  CargueMasivoFiviAdminInfoToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      //debugger;
      let str = '';
      let row = 'CONSECUTIVO;';
      for (let index in headerList) {
              row += headerList[index] + ';';
          }
          row = row.slice(0, -1);
          str += row + '\r\n';
          for (let i = 0; i < array.length; i++) {
              let line = (i+1)+'';
              for (let index in headerList) {
                  let head = headerList[index];
                  line += ';' + array[i][head];
              }
              str += line + '\r\n';
          }
          return str;
  }

  DescargaPanel3Opertaivo(data, filename='data'){
    let csvData = this.Panel3ToCSV(data, ['CODIGO_ENTIDAD','RAZON_SOCIAL', 'ESTADO']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  Panel3ToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      //debugger;
      let str = '';
      let row = 'No.;';
      for (let index in headerList) {
              row += headerList[index] + ';';
          }
          row = row.slice(0, -1);
          str += row + '\r\n';
          for (let i = 0; i < array.length; i++) {
              let line = (i+1)+'';
              for (let index in headerList) {
                  let head = headerList[index];
                  line += ';' + array[i][head];
              }
              str += line + '\r\n';
          }
          return str;
  }



  generateExcelBase64AdminInfoConsultarInformacion(columnNames: string[], columnData: VistaAdminInfoI[]): string {

    const dataRows = columnData.map(item => {
      return [
        item.perido,
        item.nit,
        item.razonSocial,
        item.depto,
        item.muni,
        item.estadocargue,
        item.estadofuente,
        item.novedad
      ];
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([columnNames, ...dataRows]);

    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer: Uint8Array = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    let binary = '';
    const bytes = new Uint8Array(excelBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64String = btoa(binary);

    return base64String;
  }

  generateExcelBase64AdminInfoConsultarInfoHistorico(columnNames: string[], columnData: ResCargueExcel[]): string {

    const dataRows = columnData.map(item => {
      return [
        item.consecutivo,
        item.anio,
        item.trimestre,
        item.cod_super,
        item.cod_tipo_entidad,
        item.codigo_entidad,
        item.tipo_de_credito,
        item.departamento,
        item.municipio,
        item.solucion_vivienda,
        item.tenedor,
        item.moneda,
        item.rango_vivienda,
        item.mora,
        item.numero_creditos,
        item.saldo_capital_total,
        item.capital_una_mas_cuotas_vencidad,
        item.tasa
      ];
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([columnNames, ...dataRows]);

    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer: Uint8Array = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    let binary = '';
    const bytes = new Uint8Array(excelBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64String = btoa(binary);

    return base64String;
  }

  generateExcelBase64AdminInfoConsultarBaseHistoricaCHV(columnNames: string[], columnData: ResCargueExcel[]): string {

    const dataRows = columnData.map(item => {
      return [
        item.anio,
        item.trimestre,
        item.cod_super,
        item.cod_tipo_entidad,
        item.codigo_entidad,
        item.tipo_de_credito,
        item.departamento,
        item.municipio,
        item.solucion_vivienda,
        item.tenedor,
        item.moneda,
        item.rango_vivienda,
        item.mora,
        item.numero_creditos,
        item.saldo_capital_total,
        item.capital_una_mas_cuotas_vencidad,
        item.tasa
      ];
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([columnNames, ...dataRows]);

    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer: Uint8Array = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    let binary = '';
    const bytes = new Uint8Array(excelBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64String = btoa(binary);

    return base64String;
  }

  generateCSVBase64AdminInfoConsultarBaseHistoricaCHV(columnNames: string[], columnData: ResCargueExcel[]): string {
    // Convierte los nombres de las columnas en una cadena CSV
    const csvRows: string[] = [];
    csvRows.push(columnNames.join(';')); // Agregar encabezados separados por comas

    // Convierte cada fila de datos en formato CSV
    columnData.forEach(item => {
      const row = [
        item.anio,
        item.trimestre,
        item.cod_super,
        item.cod_tipo_entidad,
        item.codigo_entidad,
        item.tipo_de_credito,
        item.departamento,
        item.municipio,
        item.solucion_vivienda,
        item.tenedor,
        item.moneda,
        item.rango_vivienda,
        item.mora,
        item.numero_creditos,
        item.saldo_capital_total,
        item.capital_una_mas_cuotas_vencidad,
        item.tasa
      ].join(';'); // Une los valores de la fila con comas
      csvRows.push(row);
    });

    // Une todas las filas con saltos de línea
    const csvContent = csvRows.join('\n');

    // Convierte la cadena CSV a Base64
    const base64String = btoa(unescape(encodeURIComponent(csvContent)));

    return base64String;
  }

  generateExcelBase64AdminInfoConsultarBaseHistoricaFIVI(columnNames: string[], columnData: any[]): string {

    const dataRows = columnData.map(item => {
      return [
        item.anio,
        item.mes,
        item.cod_super,
        item.cod_tipo_entidad,
        item.codigo_entidad,
        item.cod_oper_fin,
        item.sexo_TITULAR,
        item.edad_titular,
        item.des_cre,
        item.solu_viv,
        item.des_cre_vivi,
        item.des_cre_cons,
        item.depto,
        item.municipio,
        item.cod_dept_viv,
        item.cod_mun_viv,
        item.sub_sn,
        item.tip_sub,
        item.moneda,
        item.ran_viv,
        item.num_cred,
        item.val_avaluo,
        item.num_desem,
        item.val_cred,
        item.plaz_cred
      ];
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([columnNames, ...dataRows]);

    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer: Uint8Array = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    let binary = '';
    const bytes = new Uint8Array(excelBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64String = btoa(binary);

    return base64String;
  }

  generateExcelBase64ControlOperatioPanel3(columnNames: string[], columnData: Panel3OperativoI[]): string {

    const dataRows = columnData.map(item => {
      return [
        item.codigoEntidad,
        item.razonSocial,
        item.estado
      ];
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([columnNames, ...dataRows]);

    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer: Uint8Array = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    let binary = '';
    const bytes = new Uint8Array(excelBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64String = btoa(binary);

    return base64String;
  }







}
